import {Field} from 'quickstart/components/controls/Field'
import {Stack} from 'quickstart/components/layout/Stack'
import {ComponentProps, ReactNode} from 'react'
import * as AK from '@ariakit/react'
import * as S from './styles'

interface RadiosProps {
  name: string
  label?: ComponentProps<typeof Field.Group>['label']
  onChange?: (v: string) => void
  options?: Array<{value: string; label: ReactNode}>
  spacing?: ComponentProps<typeof Stack>['spacing']
  value?: string
}

export const Radios = ({
  name,
  label,
  onChange,
  options = [],
  spacing = 'xs',
  value,
}: RadiosProps) => {
  const store = AK.useRadioStore({value})
  return (
    <AK.RadioGroup
      store={store}
      render={({children, ...renderProps}) => (
        <Field.Group label={label} {...renderProps}>
          <Stack spacing={spacing}>{children}</Stack>
        </Field.Group>
      )}
    >
      {options.map((o, i) => {
        const checked = value === o.value
        return (
          <S.Wrapper key={i}>
            <AK.Radio
              name={name}
              value={o.value}
              checked={checked}
              render={<S.Radio />}
              onChange={e => (e.target as any).checked && onChange?.(o.value)}
            />
            <S.Label checked={checked}>{o.label}</S.Label>
          </S.Wrapper>
        )
      })}
    </AK.RadioGroup>
  )
}
